import React, { useState, useEffect } from 'react';
import * as Utils from '../../common/utils';
import * as REQUEST from "../../common/request";
import './index.less';

const PageModel = props => {
    const [url, setUrl] = useState('');
    const [list, setList] = useState([]);

    const getbanner = async () => {
        const result = await REQUEST.get({
            url: '/zhujiajiao/v2/file/get',
            data: { id: 5 }
        });
        if (!result) return;
        setUrl(result.data.link);
    };
    const getList = async () => {
        const originalData = await REQUEST.get({
            url: '/zhujiajiao/v2/intro/list',
        });
        if (!originalData) return;

        const typeList = await REQUEST.get({
            url: '/zhujiajiao/v2/introType/list',
        });
        if (!typeList) return;

        // 按type分类
        const groupedData = originalData.data.reduce((acc, item) => {
            if (!acc[item.type]) {
                acc[item.type] = [];
            }
            acc[item.type].push(item);
            return acc;
        }, {});

        // 对每个分类按sort降序排序
        for (const type in groupedData) {
            groupedData[type].sort((a, b) => b.sort - a.sort);
        }

        // 转换为数组形式
        const result = Object.keys(groupedData).map(type => ({
            type: parseInt(type),
            items: groupedData[type]
        }));

        if(typeList.data.length > 0 && result.length > 0){
            for (let i = 0; i < result.length; i++) {
                for (let j = 0; j < typeList.data.length; j++) {
                    if (result[i].type === typeList.data[j].id) {
                        result[i].title = typeList.data[j].name;
                        result[i].description = typeList.data[j].desc;
                        result[i].sort = typeList.data[j].sort;
                    }
                }
            }
        }
        
        // 按 sort 降序排序（最大的排最前面）
        result.sort((a, b) => b.sort - a.sort);

        // 对每个分类下的 items 也按 sort 降序排序
        result.forEach(group => {
            group.items.sort((a, b) => b.sort - a.sort);
        });
        setList(result);
    };
    useEffect(() => {
        getList();
        getbanner();
        Utils.setPageTitle('景点介绍');
        return () => false;
    }, [123]);
    return (
        <section className="h5intro-container" style={{ minHeight: window.innerHeight }}>
            <div className='h5tran-top-img'>
                <img src={'https://static-yeekin.oss-cn-shanghai.aliyuncs.com/' + url} alt="" />
            </div>

            <div className='h5intro-top'>
                {
                    list.map((item, index) => {
                        return (
                            <div className='h5intro-top-item' key={index}>
                                <div className='h5intro-top-item-title'>{item.title}</div>
                                <div className='h5intro-top-item-content'>{item.description}</div>
                                <div className='h5intro-top-item-list'>
                                    {item.items.map((item2, index2) => {
                                        return (
                                            <div className='h5intro-top-item-list-item' key={index2} onClick={()=>{
                                                props.history.push(`/zhujiajiao/h5intro/${item2.id}`);
                                            }}>
                                                <img src={'https://static-yeekin.oss-cn-shanghai.aliyuncs.com/'+item2.cover} alt="" ></img>
                                                <div className='h5intro-top-item-list-item-title'>{item2.title}</div>
                                            </div>
                                        )
                                    })
                                    }
                                </div>
                            </div>
                        )
                    })
                }
            </div>

            
            <div className='h5intro-bottom-img'>
                <img src={require('./images/bottom.png')} alt="" />
            </div>
        </section>
    );
};

export default PageModel;
